import { compose } from 'redux'

import WithHOC from './actions'
import KYCMember from './Member'
import KYCCustomer from './Customer'

const KYCSubmission = props => {
  return (
    <>
      {
        props.profile?.role_name?.toLowerCase().indexOf( 'customer' ) > -1
          ? <KYCCustomer { ...props }/>
          : <KYCMember { ...props }/>
      }
    </>
  )
}

export default compose(
  WithHOC
)( KYCSubmission )
